import { CreationError, } from '@office-start/create-types';
import { appendQueryParams } from '@office-start/url-parser-utility';
function handleError(message) {
    throw new CreationError(message !== null && message !== void 0 ? message : 'getDocAspxApiUrl failed', "Error" /* CreateDocumentResultType.Error */);
}
// eslint-disable-next-line max-params
export function getDocAspxApiUrl(docTypeId, origin, clickTime, options, templateId, driveId, docAspxForPpeEnabled) {
    var _a, _b, _c, _d, _e, _f;
    if (!options.myDriveRootUrls || !options.myDriveRootUrls.userRoot) {
        return handleError('Failed to get doclib url. myDriveRootUrls is undefined');
    }
    var doclibUrl = options.myDriveRootUrls.userRoot;
    var documentsIndex = doclibUrl.lastIndexOf('/Documents');
    if (documentsIndex === -1) {
        return handleError('docliburl not in expected format');
    }
    var getApiRootUrl = function (rootUrl) {
        if (!docAspxForPpeEnabled) {
            return rootUrl;
        }
        else {
            var parsedUrl = new URL(rootUrl);
            return rootUrl === null || rootUrl === void 0 ? void 0 : rootUrl.replace("".concat(parsedUrl.protocol, "//").concat(parsedUrl.hostname), 'https://www.officeppe.com/word/create');
        }
    };
    var apiRootUrl = getApiRootUrl(doclibUrl.substring(0, documentsIndex));
    var url = "".concat(apiRootUrl, "/_layouts/15/doc.aspx?action=editnew&doctype=").concat(docTypeId, "&wdOrigin=").concat(origin, "&docliburl=").concat(doclibUrl, "&ct=").concat(clickTime);
    if (templateId) {
        url =
            url +
                (driveId
                    ? "&templateDriveId=".concat(driveId, "&templateItemId=").concat(templateId)
                    : "&wdTpl=".concat(templateId));
    }
    if (templateId || ((_a = options.templatesConfig) === null || _a === void 0 ? void 0 : _a.createLcidEnabled)) {
        url += "&wdlcid=".concat((_c = (_b = options.sharedContext) === null || _b === void 0 ? void 0 : _b.officeMarketLcid) !== null && _c !== void 0 ? _c : '');
    }
    var scenarioId = (_d = options.capabilities) === null || _d === void 0 ? void 0 : _d.scenarioId;
    if (scenarioId) {
        url += "&wdscenarioid=".concat(scenarioId);
    }
    if (((_e = options.capabilities) === null || _e === void 0 ? void 0 : _e.outgoingLoginHintEnabled) &&
        ((_f = options.identity) === null || _f === void 0 ? void 0 : _f.loginHint)) {
        url += "&login_hint=".concat(encodeURIComponent(options.identity.loginHint));
    }
    if (options.referralParams) {
        url = appendQueryParams(url, options.referralParams);
    }
    if (docAspxForPpeEnabled) {
        url += "&wdpa=1";
    }
    return url;
}
//# sourceMappingURL=getDocAspxApiUrl.js.map